module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-07.689ec15c.jpeg";